import OrganisationApi from '@packages/organisations/api';

export class RegistrarApi extends OrganisationApi {
    static resource = 'registrars';
}

export default RegistrarApi;
